import { Loader2, X } from "lucide-react";
import { useOcupaRodape } from "@/components/ajuda/RodapeOcupado";

type Props = {
  quantos: number;
  aplicando: boolean;
  onEstagio: () => void;
  onModelo: () => void;
  onResponsavel: () => void;
  onLimpar: () => void;
};

/**
 * Barra fixa que aparece quando há trabalhos selecionados na Planilha do celular. As três ações
 * abrem a mesma folha de escolha da edição unitária — a diferença é só quantos serviços recebem o
 * destino. z-40 pra ficar abaixo das folhas (z-50), que abrem por cima dela.
 */
export function MobileSelecaoBar({ quantos, aplicando, onEstagio, onModelo, onResponsavel, onLimpar }: Props) {
  const ocupaRodape = useOcupaRodape<HTMLDivElement>();
  return (
    <div ref={ocupaRodape} className="fixed inset-x-0 bottom-[calc(3.75rem+env(safe-area-inset-bottom))] z-40 border-t border-zinc-200 bg-white p-3 shadow-[0_-4px_16px_rgba(0,0,0,0.1)] md:hidden dark:border-border dark:bg-card">
      <div className="flex items-center justify-between">
        <p className="text-[13px] font-semibold text-brand-700 dark:text-primary">
          {aplicando && <Loader2 className="mr-1.5 inline h-3.5 w-3.5 animate-spin" />}
          {quantos} selecionado{quantos > 1 ? "s" : ""}
        </p>
        <button
          type="button"
          onClick={onLimpar}
          aria-label="Limpar seleção"
          className="-mr-2 flex h-11 w-11 items-center justify-center rounded-md text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-zinc-700 dark:hover:bg-muted"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
      <div className="mt-1 flex gap-2">
        {(
          [
            { rotulo: "Estágio", onClick: onEstagio },
            { rotulo: "Modelo", onClick: onModelo },
            { rotulo: "Responsável", onClick: onResponsavel },
          ] as const
        ).map(({ rotulo, onClick }) => (
          <button
            key={rotulo}
            type="button"
            disabled={aplicando}
            onClick={onClick}
            className="h-11 min-w-0 flex-1 basis-0 truncate rounded-md border border-brand-200 bg-brand-50 px-1.5 text-[clamp(10.5px,3vw,13px)] font-semibold text-brand-700 transition-colors hover:bg-brand-100 disabled:opacity-50 dark:border-primary/30 dark:bg-primary/15 dark:text-primary"
          >
            {rotulo}
          </button>
        ))}
      </div>
    </div>
  );
}
